import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CategoryService } from 'src/app/core/services/category.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { CommonService } from 'src/app/core/services/common.service';
import { SubmitConfirmationComponent } from '../submit-confirmation/submit-confirmation.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  @Input() selectedCategoryDetails: any;
  @Input() isLastSection: any;
  @Input() isLastCategory: any;
  @Input() unansweredQues: any;
  @Input() returnQues!: any;
  @Input() progressCountState: any;
  isCompleted = false
  @Output() changeSubCategory: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetReturnQues: EventEmitter<any> = new EventEmitter<any>();
  selectedCategory: string = '';
  selectedSubCategory: string = '';
  statusOfSubstages: any;
  selectedSubcategoryDetails: any;
  isArabic!: boolean;
  isAllQuestionsDone = false;
  userDetails: any;
  assessmentDetails: any;
  questionaireguid: any;
  allAnswers: any;
  modalRef!: BsModalRef;
  modalRefMsg!: BsModalRef;
  modalRefConfirm!: BsModalRef;
  modalRefDeactivate!: BsModalRef;
  responseIds: any;
  questionnaireAccountGuid: any;
  isResubmit: any;
  isChecker: any;
  isMakerCheckerEnabled: any;
  isView!: boolean;
  allQuesDone: any;
  allQuesCompleted: boolean = false;
  totalQns: any;
  notificationSubscription: any;
  notApplicableguids: any;
  allQuestions: any;
  disabledBtn: any = true;
  serverErr: any;
  isAllQuesApproved: any;
  reVisitUnAnswered: boolean = false;
  returnToAssessment: boolean = false;
  rejectedguids: any;
  isSelectedSubcategoryLast: boolean = false;
  totalAns: any = 0;


  constructor(private route: Router, private activateRoute: ActivatedRoute, private categoryService: CategoryService,
    private storageService: StorageService, private assessmentService: AssessmentService,
    private modalService: BsModalService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.assessmentDetails = this.storageService.getSessionStorageData('assessmentDetails');
    this.questionaireguid = this.assessmentDetails.questionnaireguid;
    this.questionnaireAccountGuid = this.assessmentDetails.questionnaireAccountGuid;
    this.totalQns = this.storageService.getSessionStorageData('totalQues');
    //console.log("totalques" ,this.totalQns)
    //assessmentProgressChange
    this.categoryService.answeredCount$.subscribe((value) => {
      this.assessmentDetails.answeredCount = value;
      if (this.assessmentDetails.answeredCount == this.totalQns) {
        this.allQuesDone = true;
      } else { this.allQuesDone = false; }
    });


    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      this.reVisitUnAnswered = false;
      this.returnToAssessment = false;
      if (queryParam.hasOwnProperty('action') && queryParam.action == 'resubmit') {
        this.isResubmit = true;
        this.isView = false;
      } else if (queryParam.hasOwnProperty('action') && queryParam.action == 'view') {
        this.isResubmit = false;
        this.isView = true;
      } else {
        this.isResubmit = false;
        this.isView = false;
      }
      if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'unanswered') {
        this.reVisitUnAnswered = true;
      }
      else if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'return') {
        this.returnToAssessment = true;
      }
    });
    if (!this.isResubmit) {
      this.validateAssessment()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      this.reVisitUnAnswered = false;
      this.returnToAssessment = false;
      if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'unanswered') {
        this.reVisitUnAnswered = true;
      }
      else if (queryParam.hasOwnProperty('revisittype') && queryParam.revisittype == 'return') {
        this.returnToAssessment = true;
      }
    });
    if (changes.hasOwnProperty('selectedCategoryDetails')) {
      this.loadCategory();
    }
    //assessmentProgressChange
    if (changes.hasOwnProperty('progressCountState')) {
      this.totalAns = this.progressCountState?.totalAnswers ? this.progressCountState?.totalAnswers : 0;
      if (this.totalAns == this.totalQns) {
        this.allQuesCompleted = true;
      }
      else {
        this.allQuesCompleted = false;
      }

    }
  }

  handleResetReturnQues() {
    this.resetReturnQues.emit();
  }

  loadCategory() {
    this.selectedCategory = this.selectedCategoryDetails?.category;
    this.selectedSubcategoryDetails = this.selectedCategoryDetails?.subCategoryList?.find((eachSubstage: any) =>
      eachSubstage?.isCompleted === false);
    this.selectedSubCategory = this.selectedSubcategoryDetails?.subCategory;
    if (this.reVisitUnAnswered) {
      this.selectedSubcategoryDetails = this.selectedCategoryDetails?.subCategoryList?.find((eachSubStage: any) =>
        eachSubStage?.subCategory == this.unansweredQues?.subCategory);
      this.selectedSubCategory = this.unansweredQues?.subCategory;
    }
    if (this.returnToAssessment &&
      this.returnQues && this.returnQues?.subcategory) {
      this.selectedSubcategoryDetails = this.selectedCategoryDetails?.subCategoryList?.find((eachSubStage: any) =>
        eachSubStage?.subCategory == this.returnQues?.subcategory);
      this.selectedSubCategory = this.returnQues?.subcategory;
    }
    this.changeSubcategory(this.selectedSubCategory);
  }

  changeSubcategory(subcategoryName: string) {
    this.selectedSubCategory = subcategoryName;
    this.selectedSubcategoryDetails = this.selectedCategoryDetails?.subCategoryList?.find((item: any) =>
      item?.subCategory == this.selectedSubCategory);
    this.checkLastSubcategoryStatus();
  }
  checkLastSubcategoryStatus() {
    this.isSelectedSubcategoryLast = false;
    if (this.selectedCategoryDetails?.subCategoryList?.indexOf(this.selectedSubcategoryDetails) == this.selectedCategoryDetails?.subCategoryList?.length - 1) {
      this.isSelectedSubcategoryLast = true;
    }
  }

  checkSubcategoryStatus(status: any) {
    if (status) {
      let index = this.selectedCategoryDetails?.subCategoryList?.findIndex((ele: any) => ele?.subCategory === this.selectedSubCategory);
      if (index < (this.selectedCategoryDetails?.subCategoryList?.length - 1)) {
        this.selectedSubCategory = this.selectedCategoryDetails?.subCategoryList[index + 1]?.subCategory;
        this.changeSubcategory(this.selectedSubCategory);
      } else {
        this.categoryService.setCategoryChange(true);
      }
    }
  }

  callSubmitAssessment() {
    //console.log("isChecker flag ", this.isChecker)
    //console.log("isResubmit flag ", this.isResubmit)

    // if (this.isChecker) {
    if (this.isChecker && !this.isResubmit) {
      //console.log("checkerSubmitQuestionnaire calling")
      this.checkerSubmitQuestionnaire();
    } else {
      //console.log("submitQuestionnaire calling")

      this.submitQuestionnaire();
    }
  }

  checkerSubmitQuestionnaire() {
    let totalQues = this.storageService.getSessionStorageData('totalQues');

    const rqstBody = {
      questionnaire: this.questionaireguid,
      isChecker: this.isChecker,
      assessmentUnit: this.userDetails.assessmentUnitValue,
      contactguid: this.userDetails.contactguid
    }
    this.assessmentService.checkAllQuesReviewed(rqstBody).subscribe((data) => {
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
      let approvedResponseIds = decryptedData?.responseguids;
      let rejectedResponseIds = decryptedData?.rejectedguids;
      if (totalQues == (approvedResponseIds.length + rejectedResponseIds.length)) {
        if (totalQues == approvedResponseIds.length && rejectedResponseIds.length == 0) {
          this.isAllQuesApproved = true;
        }
        else {
          this.isAllQuesApproved = false
        }
        //console.log("checker submit open popup")
        //console.log("resp ids ", approvedResponseIds)
        //console.log("rejected ids ", rejectedResponseIds)

        this.openConfirmationComp();
        //console.log("openConfirmationComp approved true")
      } else {
        this.isAllQuesApproved = false;
        //console.log("openConfirmationComp approved false")

        this.openErrorPopup();
      }
      this.disabledBtn = false;
    }, (error: any) => {
      //console.log("checkersubmitques error ", error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      } else {
        this.serverErr = error?.body?.error;
      }
      this.disabledBtn = false;
    });
  }

  submitQuestionnaire() {
    let totalQues = this.storageService.getSessionStorageData('totalQues');

    const rqstBody = {
      questionnaire: this.questionaireguid,
      isChecker: this.isChecker,
      assessmentUnit: this.userDetails.assessmentUnitValue,
      contactguid: this.userDetails.contactguid,
      isResubmit: this.isResubmit,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    }
    this.disabledBtn = true;
    this.assessmentService.checkAllQuesSubmitted(rqstBody).subscribe((data) => {
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
      this.responseIds = decryptedData?.responseguids;
      this.notApplicableguids = decryptedData?.notApplicableguids;
      this.rejectedguids = decryptedData?.rejectedguids;
      //console.log("submit questionaire response", decryptedData)
      //console.log("resubmittedCount", this.storageService.getSessionStorageData("resubmittedCount"))
      if (this.isResubmit) {
        //console.log("resubmit flow")
        if (this.rejectedguids?.length > 0) {
          this.disabledBtn = false;
          this.openConfirmationComp();

        }
        else {
          this.openErrorPopup();

        }
        // console.log("resubmit rejectedguids ",this.rejectedguids)
        // if (this.rejectedguids?.length === this.storageService.getSessionStorageData("resubmittedCount")) {
        //   console.log("resubmit openconf popup", this.responseIds, this.rejectedguids, this.notApplicableguids)
        //   console.log("responseIds", this.responseIds)
        //   console.log("rejectedguids", this.rejectedguids)
        //   console.log("notApplicableguids", this.notApplicableguids)

        //   console.log("submitquestionarire openConfirmationComp")
        //   this.openConfirmationComp();

        // } else {
        //   console.log("submitquestionarire openConfirmationComp mismatch resubmitted count")

        //   this.openConfirmationComp();
        // }
      } else {
        //console.log("normal ")
        //console.log("responseIds ",this.responseIds.length)
        //console.log("totalQues ",totalQues)

        if (totalQues == this.responseIds.length) {
          //console.log("submitquestionarire openConfirmationComp  all ques ansuwered")

          if (this.notApplicableguids.length > 0) {
            //console.log("submitquestionarire notApplicableguids", this.notApplicableguids.length)

            let pendingQues = 0;
            const rqstBody = {
              questionnaire: this.questionaireguid
            }
            this.assessmentService.fetchAllQuestions(rqstBody).subscribe((data) => {
              let decryptedData = this.commonService.decryptUsingAES256(data?.data);
              this.allQuestions = decryptedData?.questionsList;
              if (this.allQuestions.length > 0 && this.responseIds.length > 0) {
                this.notApplicableguids?.forEach((eachQuesGuid: any) => {
                  let notApplicableQuesDetailsArr = this.allQuestions?.filter((eachQues: any) => eachQues?.quesguid == eachQuesGuid);

                  let parentQuesDetailsArr = this.responseIds?.filter((eachQuesAns: any) => notApplicableQuesDetailsArr[0]?.parentguid == eachQuesAns?.quesguid);


                  if (parentQuesDetailsArr[0]?.responseValue == notApplicableQuesDetailsArr[0]?.basedOnValue) {
                    pendingQues++;
                  } else {
                    let parentQuesTypeDetailsArr = this.allQuestions?.filter((eachQues: any) => eachQues?.quesguid == notApplicableQuesDetailsArr[0]?.parentguid);
                    if (parentQuesTypeDetailsArr[0].controlType == 'multiselect') {
                      let parentQuesRespArr = parentQuesDetailsArr[0]?.responseValue?.split(',');
                      let idx = parentQuesRespArr?.findIndex((eleResp: any) => eleResp?.toLowerCase() == notApplicableQuesDetailsArr[0]?.basedOnValue?.toLowerCase());
                      if (idx > -1) {
                        pendingQues++;
                      }
                    }
                  }
                });
                if (pendingQues > 0) {
                  this.disabledBtn = false;
                  this.openErrorPopup();
                } else {
                  //console.log("submit questionaire opening conf popup nopendingQues")
                  this.openConfirmationComp();
                }
              } else {
                //console.log("submit questionaire opening error popup")

                this.disabledBtn = false;
                this.openErrorPopup();
              }
            }, (error: any) => {
              this.serverErr = error?.body?.error;
              this.disabledBtn = false;
            });
          } else {
            //console.log("notApplicableguids 0 open confirm popup", this.notApplicableguids.length)
            this.openConfirmationComp();
          }
        } else {
          this.disabledBtn = false;
          this.openErrorPopup();
        }
      }
    }, (error: any) => {
      //console.log("submitquestionare error ", error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      } else {
        this.serverErr = error?.body?.error;
      }
      this.disabledBtn = false;
    });
  }

  openErrorPopup() {
    let message = '';
    if (this.isChecker) {
      if (this.isArabic) {
        message = 'يرجى مراجعة جميع الأسئلة قبل تقديم التقييم.';
      } else {
        message = 'Please review all questions before submitting the assessment.';
      }
    } else {
      if (this.isArabic) {
        message = 'يرجى إكمال جميع الأسئلة قبل تقديم التقييم.';
      } else {
        message = 'Please complete all questions before submitting the assessment.';
      }
    }

    const initialState = {
      message: message,
      redirectTo: '',
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { initialState });
    this.disabledBtn = false;

  }

  openConfirmationComp() {
    //console.log("inside openConfirmationComp")
    let message = '';
    let messageOne = '';
    if (this.isArabic) {
      message = '';
      messageOne = 'هل انت متأكد من رغبتك في التقدم؟';
    } else {
      message = '';
      messageOne = 'Are you sure you want to proceed ?';
    }

    const initialState = {
      message: message,
      messageOne: messageOne,
      redirectTo: '',
      cancelButton: true
    };
    this.modalRefConfirm = this.modalService.show(SubmitConfirmationComponent, { initialState });

    this.notificationSubscription = this.categoryService.submitConfirmationStatus$.subscribe((value) => {
      if (value == 'ok') {
        //console.log("ok")
        this.categoryService.setConfirmation(null);
        // if (this.isChecker) {
        if (this.isChecker && !this.isResubmit) {
          //console.log("if this.isChecker && !this.isResubmit")

          this.disabledBtn = true;
          this.callSaveQuestionnaire();
        } else {
          //console.log("else block re submit not checker", this.responseIds)
          this.disabledBtn = true;
          //let allResponseIds = this.responseIds.map((ele: any) => ele.executorRespId);
          if (this.isResubmit) {
            this.responseIds = this.rejectedguids
          }
          let allResponseIds = this.responseIds.map((ele: any) => {
            let res: any = { id: ele.executorRespId }

            if (ele?.comments && ele?.comments != '') {
              // console.log("comments", ele.comments)
              let history = "";
              //let userComment = this.userDetails?.firstname + " " + this.userDetails?.lastname + ": " + ele?.comments
              const currentDate = new Date();

              const day = String(currentDate.getDate()).padStart(2, '0');
              const month = String(currentDate.getMonth() + 1).padStart(2, '0');
              const year = currentDate.getFullYear();

              let dateString = `${day}.${month}.${year}`;
              let userComment = `${this.userDetails?.firstname} ${this.userDetails?.lastname} - ${dateString} : ${ele?.comments}`;

              if (ele?.commentHistory && ele?.commentHistory != '') {
                // console.log("comment history", ele.commentHistory)
                history = userComment  + "\n" + ele?.commentHistory;
              }
              else if (ele?.commentHistory == '' ||
                ele?.commentHistory == null ||
                ele?.commentHistory == undefined ||
                ele?.commentHistory == 'null' ||
                ele?.commentHistory == 'undefined'
              ) {
                history = userComment;
              }
              res["commentHistory"] =this.sortCommentsByDateDesc(history);
              // console.log("sorted history", res["commentHistory"])
            }

            return res;
          });
          let rqstBody2 = {
            respguids: allResponseIds,
            isMakerCheckerEnabled: this.isMakerCheckerEnabled,
            isChecker: this.isChecker,
            isResubmit: this.isResubmit
          };
          // console.log("calling submitquesresponse", rqstBody2)
          this.assessmentService.submitQuestionResponses(rqstBody2).subscribe(
            (data2) => {
              (async () => {
                try {
                  let decryptedData2 = this.commonService.decryptUsingAES256(data2?.data);
                  //console.log("response ", decryptedData2);

                  if (decryptedData2?.isCompleted === true) {
                    await this.validateAssessment();

                    // Your logic seems inverted, but assuming it's correct:
                    if (!this.isValidAssessment) {
                      console.warn("Validation failed: Assessment is not submitted.");
                      alert("Assessment is not submitted. Please resubmit");
                      this.disabledBtn = false;
                      return;
                    }

                    //console.log("callsavequestionare");
                    this.callSaveQuestionnaire();
                  }
                } catch (err) {
                  console.error('Error inside async validation handling:', err);
                  this.disabledBtn = false;
                }
              })();
            },
            (error: any) => {
              //console.log("submitquestresponse error", error);
              if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
                this.showDeactivationPopup();
              } else {
                this.serverErr = error?.body?.error;
              }
              this.disabledBtn = false;
            }
          )
        }
      } else {
        //console.log("cancel")
        this.disabledBtn = false;
      }
    });
  }
   sortCommentsByDateDesc(commentHistory: string): string {
    if (!commentHistory) return '';

    const comments = commentHistory.split('\n').filter(line => line.trim() !== '');

    // Parse date and create array of objects with date and original comment
    const commentsWithDate = comments.map(commentLine => {
      // Extract date with regex: looks for DD.MM.YYYY pattern anywhere after a dash
      const dateRegex = /- (\d{2})\.(\d{2})\.(\d{4})[: ]/;
      const match = commentLine.match(dateRegex);

      let dateObj: Date;

      if (match) {
        const day = Number(match[1]);
        const month = Number(match[2]) - 1; // JS months start from 0
        const year = Number(match[3]);
        dateObj = new Date(year, month, day);
      } else {
        // If no date found, assign an old date so it goes to the bottom
        dateObj = new Date(0);
      }

      return {
        line: commentLine,
        date: dateObj
      };
    });

    // Sort descending by date
    commentsWithDate.sort((a, b) => b.date.getTime() - a.date.getTime());
    // Join back lines
    return commentsWithDate.map(c => c.line).join('\n');
  }
  callSaveQuestionnaire() {
    this.disabledBtn = true; // Disable button immediately on submit

    const rqstBody3 = {
      assessmentunitguid: this.assessmentDetails.assessmentunitguid,
      quesnaireguid: this.questionaireguid,
      contactguid: this.userDetails.contactguid,
      submitTime: new Date(),
      questionnaireAccountGuid: this.questionnaireAccountGuid,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled,
      isAllApproved: this.isAllQuesApproved,
      isResubmit: this.isResubmit
    };

    this.assessmentService.saveQuestionnaire(rqstBody3).subscribe({
      next: (data3) => {
        let decryptedData3 = this.commonService.decryptUsingAES256(data3?.data);
        if (decryptedData3?.isSubmitted === true) {
          // Show success modal
          let message = this.isArabic ? 'تم تسليم التقييم بنجاح' : 'Assessment has been submitted successfully.';
          let pathUrl = '';

          if (this.isChecker) {
            //console.log("checkert callsaveques")
            pathUrl = this.isResubmit ? 'executor-dashboard/monitoring/resubmit' : 'executor-dashboard/monitoring/review';
          } else if (this.isResubmit) {
            //console.log("isResubmit callsaveques")

            pathUrl = 'executor-dashboard/resubmit-clarify';
          } else {
            pathUrl = 'executor-dashboard/assessment';
          }

          const initialState = {
            message: message,
            messageOne: '',
            redirectTo: pathUrl,
            cancelButton: false
          };

          this.modalRefMsg = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
          this.modalRefMsg.onHidden?.subscribe(() => {
            this.route.navigate([pathUrl]); // Make sure Router is injected in constructor
          });

        } else {
          this.disabledBtn = false;
        }
      },
      error: (error) => {
        if (error?.body?.error === 'The Assossicated Assessment Entity has deactivated') {
          this.showDeactivationPopup();
        } else {
          this.serverErr = error?.body?.error;
        }
        this.disabledBtn = false;
      }
    });
  }
  callSaveQuestionnaireOld() {
    const rqstBody3 = {
      assessmentunitguid: this.assessmentDetails.assessmentunitguid,
      quesnaireguid: this.questionaireguid,
      contactguid: this.userDetails.contactguid,
      submitTime: new Date(),
      questionnaireAccountGuid: this.questionnaireAccountGuid,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled,
      isAllApproved: this.isAllQuesApproved,
      isResubmit: this.isResubmit
    }
    this.assessmentService.saveQuestionnaire(rqstBody3).subscribe((data3) => {
      let decryptedData3 = this.commonService.decryptUsingAES256(data3?.data);
      if (decryptedData3?.isSubmitted === true) {
        let message = '';
        let messageOne = '';
        let pathUrl = '';
        if (this.isArabic) {
          message = 'تم تسليم التقييم بنجاح'
          messageOne = '';
        } else {
          message = 'Assessment has been submitted successfully.';
          messageOne = '';
        }
        if (this.isChecker) {
          if (this.isResubmit) {
            pathUrl = 'executor-dashboard/monitoring/resubmit';
          }
          else {
            pathUrl = 'executor-dashboard/monitoring/review';
          }
        }
        else if (this.isResubmit) {
          pathUrl = 'executor-dashboard/resubmit-clarify';
        }
        else {
          pathUrl = 'executor-dashboard/assessment';
        }
        const initialState = {
          message: message,
          messageOne: messageOne,
          redirectTo: pathUrl,
          cancelButton: false
        };
        this.modalRefMsg = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
      } else {
        this.disabledBtn = false;
      }
    }, (error: any) => {
      //console.log(error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      } else {
        this.serverErr = error?.body?.error;
      }

      this.disabledBtn = false;
    });
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }
  onChildComplete() {
    this.disabledBtn = false;
  }
  isValidAssessment = false
  async validateAssessment() {
    let rqstBody = { AssessmentAccountId: this.questionnaireAccountGuid };

    try {
      // Convert Observable to Promise and await the response
      const res = await this.assessmentService.validateAssessment(rqstBody).toPromise();

      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log(resp);

      if (resp && resp?.IsValid) {
        this.isValidAssessment = true;  // valid, proceed to submit
        this.disabledBtn = false;
      } else {
        this.isValidAssessment = false;  // invalid, alert user
      }
    } catch (error) {
      console.error('Error validating assessment', error);
      this.isValidAssessment = false;
    }

    return this.isValidAssessment;
  }
}
